'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _directionalProperty = /*#__PURE__*/require('../helpers/directionalProperty');

var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */

function borderStyle() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return _directionalProperty2.default.apply(undefined, ['borderStyle'].concat(values));
}
exports.default = borderStyle;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/polished/lib/shorthands/borderStyle.js
 ** module id = 1026
 ** module chunks = 0
 **/